/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.1
 */
import { memo } from 'react';

import { ESkeletonKind } from './skeletonTypes';
import { SkeletonButtonStyled } from './styled/SkeletonButtonStyled';

export interface ISkeletonButtonProps {
    kind: ESkeletonKind;
}

const SkeletonButton = (props: ISkeletonButtonProps) => <SkeletonButtonStyled kind={props.kind}/>;

export default memo(SkeletonButton);
